import CruiseResultCard from '../components/cruises/CruiseResultCard';
import CruiseResultsLayout from '../components/cruises/CruiseResultsLayout';

export default function CruiseResultsPage() {
  return (
    <CruiseResultsLayout
      renderCard={(item, searchParams) => (
        <CruiseResultCard key={item.id} item={item} searchParams={searchParams} />
      )}
    />
  );
}
